import React, { Component }  from 'react';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Order from './Order';

class ProductionOrderList extends Component {
    render() {
        let orders = this.props.orders.map((p) => (<Grid key={p.id} item xs={6}><Order editTitle={this.props.editTitle}  actions={this.props.actions} {...p}></Order></Grid>));
        return (
            <React.Fragment>
                {
                    orders.length ? 
                    <Card className="OrderList">
                        <CardHeader title={this.props.title}/>
                        <Divider/>
                        <CardContent>
                            <Grid container spacing={3}>
                                {orders}
                            </Grid>
                        </CardContent>
                    </Card> : <React.Fragment></React.Fragment>
                }
            </React.Fragment>
        )
    }
}

export default ProductionOrderList;